
(() => {
  const EXPERIENCE_ID = "jdgm_question_label_255329";
  const GIFT_ID = "jdgm_question_label_255197";
  const GIFT_VALUE = "I purchased the letters as a gift.";

  const FIELD_SELECTOR =
    ".jdgm-write-review-modal__field-group.jdgm-cf";

  function updateGiftVisibility() {
    const experienceLabel = document.getElementById(EXPERIENCE_ID);
    const giftLabel = document.getElementById(GIFT_ID);

    if (!experienceLabel || !giftLabel) return;

    const experienceGroup = experienceLabel.closest(FIELD_SELECTOR);
    const giftGroup = giftLabel.closest(FIELD_SELECTOR);

    if (!experienceGroup || !giftGroup) return;

    const selected = experienceGroup.querySelector(
      'input[type="radio"]:checked'
    );

    const isGift = selected?.value === GIFT_VALUE;

    if (!isGift) {
      // Clear all previously selected gifting answers.
      giftGroup.querySelectorAll(
        'input[type="checkbox"]:checked, input[type="radio"]:checked'
      ).forEach(input => {
        input.click();
      });

      // Clear text answers, if added in the future.
      giftGroup.querySelectorAll(
        'textarea, input[type="text"]'
      ).forEach(input => {
        if (input.value) {
          input.value = "";
          input.dispatchEvent(
            new Event("input", { bubbles: true })
          );
          input.dispatchEvent(
            new Event("change", { bubbles: true })
          );
        }
      });
    }

    giftGroup.style.display = isGift ? "" : "none";
  }

  function initialize() {
    const observer = new MutationObserver(updateGiftVisibility);

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    document.addEventListener("change", event => {
      if (event.target.matches(
        'input[type="radio"][name="cf_answers[255329][value]"]'
      )) {
        updateGiftVisibility();
      }
    });

    updateGiftVisibility();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initialize);
  } else {
    initialize();
  }
})();
